<template>
    <div>
        <section class="section-padding" id="testdrive">
            <div class="container">
                <div class="section-header text-center">
                    <h2>Agenda <span>Tu Test Drive</span></h2>
                    <h3>
                        <span>
                           Diligencie la siguiente información para agendar tu cita.
                        </span>
                    </h3>
                </div>
                <div class="row">
                    <div class="col-md-5 col-sm-12">
                        <div class="row mt-3">
                            <div class="col-md-12 text-center">
                                <b-card>
                                    <b-row>
                                        <b-col md="12" class="text-center mb-2">
                                            <!-- Imagen principal del vehículo -->
                                            <img
                                                :src="'https://brokcars-assets.s3.us-east-2.amazonaws.com/' + consignacion.inspeccion.proceso.fotos.foto_principal"
                                                class="img-fluid"
                                                alt="image"
                                            />
                                        </b-col>
                                        <b-col md="12">
                                            <div>
                                                <h4 class="m-0">
                                                    <i class="fa fa-car"></i>
                                                    {{ consignacion.vehiculo.marca }}
                                                    {{ consignacion.vehiculo.linea }}
                                                </h4>
                                                <h5 class="grey-text">
                                                    {{ consignacion.vehiculo.modelo }} |
                                                    {{
                                                        consignacion.vehiculo.kilometraje
                                                            | formatNumber
                                                    }}
                                                    km
                                                </h5>
                                                <h5 class="text-red">
                                                    ${{
                                                        consignacion.vehiculo.precio_publicacion
                                                            | formatNumber
                                                    }}
                                                </h5>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 col-sm-12">
                        <datosForm v-if="asistenteStepData == ''"/>
                        <responseForm v-if="asistenteStepData == 'response'"/>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import datosForm from './frontFormDatos';
import responseForm from "./frontFormResponse";
export default {
    props: ['consignacion'],
    components: {
        datosForm,
        responseForm
    },
    computed: {
        asistenteStepData() {
            return this.$store.state.testDrive.asistente_step;
        },
        ...mapFields("testDrive", [
            "id_consignacion",
            "asistente_step"
        ]),
    },
    mounted() {
        this.id_consignacion = this.consignacion._id;
        var path = window.location.pathname;
        if(path === '/test_drive_reservado') {
            this.asistente_step = 'response';
        }
    }
};
</script>
<style lang="scss">

</style>
